import type { TStaffMember } from '@/services/staff';

const toStaffDisplayName = (firstName: string, lastName: string): string => {
  const initial = lastName.trim().charAt(0);

  if (!firstName) {
    return lastName.trim();
  }

  if (!initial) {
    return firstName.trim();
  }

  return `${firstName.trim()} ${initial.toUpperCase()}.`;
};

const toStaffNameMap = (members: readonly TStaffMember[] = []): ReadonlyMap<string, string> => {
  return new Map(members.map(member => [member.userID, member.name]));
};

export {
  toStaffDisplayName,
  toStaffNameMap,
};
